<template>
  <v-tooltip
    v-if="receiversData && receiversData.length && receiversData.length > 1"
    bottom
    content-class="receiver-tooltip">
    <template v-slot:activator="{ on }">
      <div v-on="on">
        ...
      </div>
    </template>
    <v-flex class="tooltip pa-1">
      <div
        v-for="item in receiversData"
        :key="item.name"
        class="receiver">
        <div class="receiver-icon">
          <departament-icon/>
        </div>
        <div class="receiver-desc">
          <span
            v-if="item.name"
            class="black--text name">{{ item.name }}</span>
          <span
            v-if="item.organisation && item.organisation.address"
            class="address"
            span>{{ item.organisation.address }}</span>
        </div>
      </div>
    </v-flex>
  </v-tooltip>
  <span v-else>
    <span>{{ receiversData && receiversData.length ? receiversData[0].name : $t('Common.NoData') }}</span>
  </span>
</template>
<script>
export default {
  name: 'receiverTooltip',
  props: {
    receiversData: Array
  },
}
</script>
<style lang="scss" scoped>
.receiver {
  display: flex;
  padding: 4px 0;

  .receiver-desc {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    .name {

    }
    .address {
      color: #6f6f6f;
      font-size: 12px;
      line-height: 12px;
    }
  }
}
.receiver-icon {
    display: flex;
    align-items: center;
    padding-right: 14px;
  }
</style>
